import dayjs from "dayjs";

import { useTimezone } from "@web-app/api";
import { TimeFormat } from "@web-app/types";
import { timeZoneMap } from "@web-app/utils/helpers";

import Tooltip from "../Tooltip";

export default function TimelineDateTz({
  date,
  userDate,
  timezone,
  createdBy,
  isTrackingPage = false,
}: {
  createdBy?: string;
  date: Date;
  isTrackingPage?: boolean;
  timezone: Partial<keyof typeof timeZoneMap>;
  userDate: Date;
}) {
  const { userTimezone } = useTimezone();

  if (timezone === "system") {
    return (
      <span className="text-[10px] md:text-xs">
        <FormattedDate date={date} />
        {createdBy && !isTrackingPage ? ` by ${createdBy}` : ""}
      </span>
    );
  }

  return (
    <div className="relative w-auto">
      <Tooltip
        text={<FormattedDate date={userDate} timezone={userTimezone} />}
        position="top"
        tooltipClassName="w-[200px] flex justify-center"
      >
        <span className="text-[10px] md:text-xs">
          <FormattedDate date={date} timezone={timezone} />
          {createdBy && !isTrackingPage ? ` by ${createdBy}` : ""}
        </span>
      </Tooltip>
    </div>
  );
}

const FormattedDate = ({
  date,
  timezone,
}: {
  date: Date;
  timezone?: Partial<keyof typeof timeZoneMap>;
}) => {
  const { getTimezone } = useTimezone();

  if (!dayjs(date).isValid()) {
    return <span></span>;
  }

  // Convert UTC time to specified timezone for display
  const effectiveTimezone = getTimezone(timezone);
  const formatted =
    effectiveTimezone === "system"
      ? dayjs(date).format(TimeFormat.month_day_year_hour_minute_am_pm)
      : dayjs
          .utc(date)
          .tz(effectiveTimezone)
          .format(TimeFormat.month_day_year_hour_minute_am_pm_tz);

  return <span className="text-[10px] md:text-xs">{formatted}</span>;
};
